// Body scroll lock, reference-counted so nested or stacked modals do not unlock the page
// while one of them is still open.
//
// Naive `overflow: hidden` on <body> causes a visible content jump on desktop, because
// removing the scrollbar reduces the viewport width. We compensate with padding equal to
// the scrollbar width. On mobile (overlay scrollbars) that width is 0 and nothing is added.

let lockCount = 0;
let previousOverflow = "";
let previousPaddingRight = "";

export function lockBodyScroll() {
  lockCount += 1;
  if (lockCount > 1) {
    return; // already locked by another modal
  }

  const body = document.body;
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  previousOverflow = body.style.overflow;
  previousPaddingRight = body.style.paddingRight;

  body.style.overflow = "hidden";
  if (scrollbarWidth > 0) {
    const currentPadding = parseInt(window.getComputedStyle(body).paddingRight, 10) || 0;
    body.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
  }
}

export function unlockBodyScroll() {
  if (lockCount === 0) {
    return; // defensive: unlock without a matching lock
  }

  lockCount -= 1;
  if (lockCount > 0) {
    return; // another modal is still open
  }

  document.body.style.overflow = previousOverflow;
  document.body.style.paddingRight = previousPaddingRight;
}
